module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-10-8539ae45337bd032311e224fe1377908.webp";